/*
 * @Description: 案例审核编辑弹窗
 * @Author: hanpengtao
 * @Date: 2022-04-25 17:31:31
 */
import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, message } from 'antd';
import classnames from "classnames";
import { queryCaseInfo, queryPropertyList, updateEditContentInfo } from '@/api';
import PictureMode from '../PictureMode/index';
import TextMode from '../TextMode/index';
import FormInfo from '../FormInfo/index';
import './index.less';
import { translateCase } from '../../../../api';


const EditModal = (props) => {
  const { visible, setVisible, caseId, handleQuery, examineMode, handleNext  } = props;

  const [currentMode, setCurrentMode] = useState('picture'); // type: 'picture' | 'text' | 'translate'
  const [caseData, setCaseData] = useState({});
  const [imgList, setImgList] = useState([]);
  const [propertyInfo, setPropertyInfo] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [translateCaseData, setTranslateCaseData] = useState({});

  const formValue = useRef({});
  const htmlValue = useRef('');


  useEffect(() => {
    if (!visible) {
      getPropertyList(0);
    }
  }, [visible]);

  
  useEffect(() => {
    const classifyId = caseData?.caseClassifyDtos?.[0]?.id;
    if (classifyId) {
      getPropertyList(classifyId);
    }

  }, [caseData?.caseClassifyDtos?.[0]?.id]);
  //  id不同重加载
  useEffect(() => {
    if (visible && caseId) {
      getCaseInfo({ caseId });
    }
  }, [visible, caseId]);

  const onCancel = () => {
    setVisible(false);
    resetData();
    handleQuery();
  }

  const onOk = () => {
    setVisible(false);
  }

  const resetData = () => {
    setCurrentMode('picture');
    setCaseData({});
    setImgList([]);
  }

  const onTextChange = (html) => {
    htmlValue.current = html;
  }

  const onFormChange = (value) => {
    formValue.current = { ...value };
  }

  const checkTitle = () => {
    const title = formValue.current.titleOrigin?.trim();
    if (!title) {
      message.info('请输入标题');
      return false;
    }
    return true;
  }

  /**
   * @description: 
   * @param {*} isReview 是否审核（模式切换仅保存）
   * @param {*} currentMode 当前模式 'picture' | 'text' | 'translate'
   */
  const handleSubmit = ({ isReview, currentMode,setChanged }) => {
    const coverImg = imgList.find(item => item.isCover);
    const delContentIdList = imgList.filter(item => item.isDelete)?.map(item => item.id);
    const submitValue = {
      type: isReview ? 0 : 1, // 0：更改状态 1：不更改状态
      reviewStatus: 1,
      cases: {
        caseId,
        titleOrigin: formValue.current.titleOrigin?.trim(),
        publishTime: formValue.current.publishTime
          ? formValue.current.publishTime.format('YYYY-MM-DD HH:mm:ss') : null,
        country: formValue.current.country || '',
        cover: coverImg?.imgUrl,
        sourceType: caseData?.caseInfo?.sourceType,
      },
      delContentIdList,
      html: htmlValue.current,
      classifyIdList: formValue.current.classifyId ? [formValue.current.classifyId] : null,
      caseLevel: formValue.current.caseLevel,
      caseStyleIdList: formValue.current.styleList,
      designList: formValue.current.designList,
      colorList: formValue.current.colorList,
      materialList: formValue.current.materialList,
      // countryList: formValue.current.countryRegion ? [formValue.current.countryRegion] : null,
      awardList: formValue.current.awardList,
      developertList: formValue.current.developert ? [formValue.current.developert] : null,
      featureList: formValue.current.featureList,
      themeList: formValue.current.theme ? [formValue.current.theme] : null,
      peopleList: formValue.current.people ? [formValue.current.people] : null,
      brandList: formValue.current.brand ? [formValue.current.brand] : null,
      caseImgType:formValue.current.caseImgType ?? null
    }
    // 切换图片/全文模式 只更新对应字段
    if (currentMode === 'picture') {
      submitValue.html = '';
    } else if (currentMode === 'text') {
      submitValue.delContentIdList = [];
    } else if (currentMode === 'translate'){
      // submitValue
    }
    saveEditInfo(submitValue).then((success) => {
      if (success) {
        if(setChanged){
          setChanged(pre => !pre);
        }
        if (isReview) {
          handleNext();
          setCurrentMode('picture')
        } else {
          getCaseInfo({ caseId });
        }
      }
    });
  }

  const handleSwitch = (newMode) => {
    // 切换触发提交
    handleSubmit({
      isReview: false,
      currentMode,
    });
    
    setCurrentMode(newMode);
  }

  const saveEditInfo = async (params) => {
    try {
      setSubmitLoading(true);
      let res = await updateEditContentInfo(params);
      if (res?.error?.errorCode == 0) {
        params?.isReview && message.success('修改成功!');
        return true;
      } else {
        message.error(res?.error?.errorMsg);
      }
    } catch (error) {
      console.error('error: ', error);
    } finally {
      setSubmitLoading(false);
    }
  }

  const getPropertyList = async (params) => {
    try {
      let res = await queryPropertyList(params);
      if (res?.error?.errorCode == 0) {
        if (res.data) {
          setPropertyInfo(res.data);
        }
      }
    } catch (error) {

    }
  }

  const getCaseInfo = async (params) => {
    try {
      let res = await queryCaseInfo(params);
      if (res?.error?.errorCode == 0) {
        if (res.data) {

          const images = [
            {
              id: null,
              imgUrl: res.data.caseInfo?.cover,
              isCover: true,
              isOriginalCover: true,
            },
            ...res.data.imgContents?.map(item => ({
              id: item.id,
              imgUrl: item.imgUrl,
              isDelete: false,
              isCover: false,
            })) ?? [],
          ];
          setImgList(images);
          setCaseData(res.data);
        }
      }
    } catch (error) {
      console.error('error: ', error);
    }
  }
  //获取翻译文本
  const getTranslateInfo = async (params) =>{
    try {
      let res = await translateCase(params);
      if (res?.error?.errorCode == 0) {
        if (res.data) {
          setTranslateCaseData(res.data);
        }
      }
    } catch (error) {
      console.error('error: ', error);
    }
  }
  return (
    <Modal
      centered
      destroyOnClose
      wrapClassName='caseCheckModal'
      width={1650}
      title={<span>{examineMode ? '案例审核' : '案例编辑'}  {caseData?.caseInfo?.remark ? <strong>审核不通过：{caseData?.caseInfo?.remark}</strong> : null}</span>}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={null}
    >
      <div className='container'>
        <div className='modalLeft'>
          <div className='btnWrapper'>
            <Button
              loading={submitLoading}
              type={currentMode === 'picture' ? 'primary' : 'default'}
              onClick={() => {
                if (checkTitle()) {
                  handleSwitch('picture');
                }
              }}
            >
              图片模式
            </Button>
            <Button
              loading={submitLoading}
              type={currentMode === 'text' ? 'primary' : 'default'}
              onClick={() => {
                if (checkTitle()) {
                  handleSwitch('text');
                }
              }}
            >
              全文模式
            </Button>
            <Button
              loading={submitLoading}
              type={currentMode === 'translate' ? 'primary' : 'default'}
              onClick={() => {
                if (checkTitle()) {
                  getTranslateInfo(caseId)
                  handleSwitch('translate');
                }
              }}
            >
              翻译模式
            </Button>
          </div>


          <PictureMode
            wrapClassName={classnames({ hidden: currentMode !== 'picture' })}
            caseData={caseData}
            imgList={imgList}
            setImgList={setImgList}
          />
          <TextMode
            type='text'
            wrapClassName={classnames({ hidden: currentMode !== 'text' })}
            caseData={caseData}
            onTextChange={onTextChange}
          />
          <TextMode
            type='translate'
            wrapClassName={classnames({ hidden: currentMode !== 'translate' })}
            caseData={translateCaseData}
            onTextChange={onTextChange}
          />
        </div>
        <div className='modalRight'>
          <FormInfo
            handleNext={handleNext}
            caseData={caseData}
            propertyInfo={propertyInfo}
            currentMode={currentMode}
            getPropertyList={getPropertyList}
            onChange={onFormChange}
            handleSubmit={handleSubmit}
            submitLoading={submitLoading}
            examineMode={examineMode}
            setVisible={setVisible}
            handleQuery={handleQuery}
          />
        </div>
      </div>
    </Modal>
  )
}

export default EditModal;